import { FORM_GET, FORM_UPDATE, FORM_CREATE } from '../actions/form'
import apiCall from './call'

const state = {
  all: false
}

const actions = {
  [FORM_GET]: ({ commit, dispatch }, data) => {
    return new Promise((resolve, reject) => {
      let url = 'forms/' + data.model

      if (data.id !== undefined) {
        url = url + '/' + data.id
      }

      apiCall({ url: url, qs: data.qs })
        .then(response => {
          resolve(response)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  [FORM_UPDATE]: ({ commit, dispatch }, data) => {
    return new Promise((resolve, reject) => {
      let url = data.model + '/' + data.id

      apiCall({ url: url, data: data.fields, qs: data.qs, method: 'PUT' })
        .then(response => {
          resolve(response)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  [FORM_CREATE]: ({ commit, dispatch }, data) => {
    return new Promise((resolve, reject) => {
      let url = data.model

      apiCall({ url: url, data: data.fields, qs: data.qs, method: 'POST' })
        .then(response => {
          resolve(response)
        })
        .catch(err => {
          reject(err)
        })
    })
  }
}

const mutations = {
  //
}

export default {
  state,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/form.js